import { Clock } from "lucide-react";

interface Props {
  open: boolean;
  secondsLeft: number;
  onStayConnected: () => void;
  onLogout: () => void;
}

function formatCountdown(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

/**
 * Aviso previo al cierre de sesión por inactividad.
 *
 * No se puede descartar haciendo clic fuera ni con Escape: si se pudiera
 * cerrar sin decidir, el usuario perdería la sesión sin enterarse.
 */
export function SessionTimeoutModal({
  open,
  secondsLeft,
  onStayConnected,
  onLogout,
}: Props) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="session-timeout-title"
    >
      <div className="mx-4 w-full max-w-sm rounded-lg bg-white p-6 shadow-xl">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-100">
            <Clock className="h-5 w-5 text-amber-600" />
          </span>
          <h2 id="session-timeout-title" className="text-lg font-semibold text-gray-900">
            ¿Sigues ahí?
          </h2>
        </div>

        <p className="mt-3 text-sm text-gray-600">
          Por seguridad, tu sesión se cerrará por inactividad en{" "}
          <span className="font-semibold tabular-nums text-gray-900">
            {formatCountdown(secondsLeft)}
          </span>
          .
        </p>

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onLogout}
            className="rounded-md px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
          >
            Cerrar sesión
          </button>
          <button
            type="button"
            onClick={onStayConnected}
            className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            Seguir conectado
          </button>
        </div>
      </div>
    </div>
  );
}
